import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderHeightService {
  height = new BehaviorSubject<number>(0);
}
